/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Area Restrita API
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AbortActingCommandResponse,
  ActingDetailQueryResponse,
  ActingQueryResponse,
  CreateActingChecklistStepBody,
  CreateActingChecklistStepCommandResponse,
  FinishActingBody,
  FinishActingCommandResponse,
  GetActingsParams,
  StartActingBody,
  StartActingCommandResponse,
  UpdateActingPositionBody,
  UpdateActingPositionCommandResponse,
  UpdatePassagerDiffBody,
  UpdatePassagerDiffCommandResponse
} from '../../model';

import { instance } from '../../index';
import type { ErrorType, BodyType } from '../../index';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getActings = (
    params: GetActingsParams,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<ActingQueryResponse>(
      {url: `/api/v1/actings`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetActingsQueryKey = (params: GetActingsParams,) => {
    return [`/api/v1/actings`, ...(params ? [params]: [])] as const;
    }

    
export const getGetActingsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getActings>>, GetActingsParams['page']>, TError = ErrorType<unknown>>(params: GetActingsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActings>>, TError, TData, Awaited<ReturnType<typeof getActings>>, QueryKey, GetActingsParams['page']>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActingsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActings>>, QueryKey, GetActingsParams['page']> = ({ signal, pageParam }) => getActings({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActings>>, TError, TData, Awaited<ReturnType<typeof getActings>>, QueryKey, GetActingsParams['page']> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetActingsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getActings>>>
export type GetActingsInfiniteQueryError = ErrorType<unknown>


export function useGetActingsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getActings>>, GetActingsParams['page']>, TError = ErrorType<unknown>>(
 params: GetActingsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActings>>, TError, TData, Awaited<ReturnType<typeof getActings>>, QueryKey, GetActingsParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActings>>,
          TError,
          Awaited<ReturnType<typeof getActings>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActingsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getActings>>, GetActingsParams['page']>, TError = ErrorType<unknown>>(
 params: GetActingsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActings>>, TError, TData, Awaited<ReturnType<typeof getActings>>, QueryKey, GetActingsParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActings>>,
          TError,
          Awaited<ReturnType<typeof getActings>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActingsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getActings>>, GetActingsParams['page']>, TError = ErrorType<unknown>>(
 params: GetActingsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActings>>, TError, TData, Awaited<ReturnType<typeof getActings>>, QueryKey, GetActingsParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetActingsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getActings>>, GetActingsParams['page']>, TError = ErrorType<unknown>>(
 params: GetActingsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActings>>, TError, TData, Awaited<ReturnType<typeof getActings>>, QueryKey, GetActingsParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetActingsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetActingsQueryOptions = <TData = Awaited<ReturnType<typeof getActings>>, TError = ErrorType<unknown>>(params: GetActingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActings>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActingsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActings>>> = ({ signal }) => getActings(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetActingsQueryResult = NonNullable<Awaited<ReturnType<typeof getActings>>>
export type GetActingsQueryError = ErrorType<unknown>


export function useGetActings<TData = Awaited<ReturnType<typeof getActings>>, TError = ErrorType<unknown>>(
 params: GetActingsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActings>>,
          TError,
          Awaited<ReturnType<typeof getActings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActings<TData = Awaited<ReturnType<typeof getActings>>, TError = ErrorType<unknown>>(
 params: GetActingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActings>>,
          TError,
          Awaited<ReturnType<typeof getActings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActings<TData = Awaited<ReturnType<typeof getActings>>, TError = ErrorType<unknown>>(
 params: GetActingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActings>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetActings<TData = Awaited<ReturnType<typeof getActings>>, TError = ErrorType<unknown>>(
 params: GetActingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActings>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetActingsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetActingsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getActings>>, TError = ErrorType<unknown>>(params: GetActingsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActings>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActingsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActings>>> = ({ signal }) => getActings(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetActingsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getActings>>>
export type GetActingsSuspenseQueryError = ErrorType<unknown>


export function useGetActingsSuspense<TData = Awaited<ReturnType<typeof getActings>>, TError = ErrorType<unknown>>(
 params: GetActingsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActings>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActingsSuspense<TData = Awaited<ReturnType<typeof getActings>>, TError = ErrorType<unknown>>(
 params: GetActingsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActings>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActingsSuspense<TData = Awaited<ReturnType<typeof getActings>>, TError = ErrorType<unknown>>(
 params: GetActingsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActings>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetActingsSuspense<TData = Awaited<ReturnType<typeof getActings>>, TError = ErrorType<unknown>>(
 params: GetActingsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActings>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetActingsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getActingDetail = (
    id: string,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<ActingDetailQueryResponse>(
      {url: `/api/v1/actings/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetActingDetailQueryKey = (id: string,) => {
    return [`/api/v1/actings/${id}`] as const;
    }

    
export const getGetActingDetailInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getActingDetail>>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActingDetail>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActingDetailQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActingDetail>>> = ({ signal }) => getActingDetail(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActingDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetActingDetailInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getActingDetail>>>
export type GetActingDetailInfiniteQueryError = ErrorType<unknown>


export function useGetActingDetailInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getActingDetail>>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActingDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActingDetail>>,
          TError,
          Awaited<ReturnType<typeof getActingDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActingDetailInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getActingDetail>>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActingDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActingDetail>>,
          TError,
          Awaited<ReturnType<typeof getActingDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActingDetailInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getActingDetail>>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActingDetail>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetActingDetailInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getActingDetail>>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActingDetail>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetActingDetailInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetActingDetailQueryOptions = <TData = Awaited<ReturnType<typeof getActingDetail>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActingDetail>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActingDetailQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActingDetail>>> = ({ signal }) => getActingDetail(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActingDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetActingDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getActingDetail>>>
export type GetActingDetailQueryError = ErrorType<unknown>


export function useGetActingDetail<TData = Awaited<ReturnType<typeof getActingDetail>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActingDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActingDetail>>,
          TError,
          Awaited<ReturnType<typeof getActingDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActingDetail<TData = Awaited<ReturnType<typeof getActingDetail>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActingDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActingDetail>>,
          TError,
          Awaited<ReturnType<typeof getActingDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActingDetail<TData = Awaited<ReturnType<typeof getActingDetail>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActingDetail>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetActingDetail<TData = Awaited<ReturnType<typeof getActingDetail>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActingDetail>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetActingDetailQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetActingDetailSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getActingDetail>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActingDetail>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActingDetailQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActingDetail>>> = ({ signal }) => getActingDetail(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActingDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetActingDetailSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getActingDetail>>>
export type GetActingDetailSuspenseQueryError = ErrorType<unknown>


export function useGetActingDetailSuspense<TData = Awaited<ReturnType<typeof getActingDetail>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActingDetail>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActingDetailSuspense<TData = Awaited<ReturnType<typeof getActingDetail>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActingDetail>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActingDetailSuspense<TData = Awaited<ReturnType<typeof getActingDetail>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActingDetail>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetActingDetailSuspense<TData = Awaited<ReturnType<typeof getActingDetail>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActingDetail>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetActingDetailSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const startActing = (
    startActingBody: BodyType<StartActingBody>,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<StartActingCommandResponse>(
      {url: `/api/v1/actings/start`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: startActingBody, signal
    },
      options);
    }
  


export const getStartActingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startActing>>, TError,{data: BodyType<StartActingBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof startActing>>, TError,{data: BodyType<StartActingBody>}, TContext> => {
    
const mutationKey = ['startActing'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startActing>>, {data: BodyType<StartActingBody>}> = (props) => {
          const {data} = props ?? {};

          return  startActing(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StartActingMutationResult = NonNullable<Awaited<ReturnType<typeof startActing>>>
    export type StartActingMutationBody = BodyType<StartActingBody>
    export type StartActingMutationError = ErrorType<unknown>

    export const useStartActing = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startActing>>, TError,{data: BodyType<StartActingBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof startActing>>,
        TError,
        {data: BodyType<StartActingBody>},
        TContext
      > => {

      const mutationOptions = getStartActingMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const finishActing = (
    id: string,
    finishActingBody: BodyType<FinishActingBody>,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<FinishActingCommandResponse>(
      {url: `/api/v1/actings/${id}/finish`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: finishActingBody, signal
    },
      options);
    }
  


export const getFinishActingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finishActing>>, TError,{id: string;data: BodyType<FinishActingBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof finishActing>>, TError,{id: string;data: BodyType<FinishActingBody>}, TContext> => {
    
const mutationKey = ['finishActing'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof finishActing>>, {id: string;data: BodyType<FinishActingBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  finishActing(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FinishActingMutationResult = NonNullable<Awaited<ReturnType<typeof finishActing>>>
    export type FinishActingMutationBody = BodyType<FinishActingBody>
    export type FinishActingMutationError = ErrorType<unknown>

    export const useFinishActing = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finishActing>>, TError,{id: string;data: BodyType<FinishActingBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof finishActing>>,
        TError,
        {id: string;data: BodyType<FinishActingBody>},
        TContext
      > => {

      const mutationOptions = getFinishActingMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const abortActing = (
    id: string,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<AbortActingCommandResponse>(
      {url: `/api/v1/actings/${id}/abort`, method: 'POST', signal
    },
      options);
    }
  


export const getAbortActingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof abortActing>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof abortActing>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['abortActing'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof abortActing>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  abortActing(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AbortActingMutationResult = NonNullable<Awaited<ReturnType<typeof abortActing>>>
    
    export type AbortActingMutationError = ErrorType<unknown>

    export const useAbortActing = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof abortActing>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof abortActing>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAbortActingMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const createActingChecklistStep = (
    id: string,
    createActingChecklistStepBody: BodyType<CreateActingChecklistStepBody>,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<CreateActingChecklistStepCommandResponse>(
      {url: `/api/v1/actings/${id}/checklistStep`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createActingChecklistStepBody, signal
    },
      options);
    }
  


export const getCreateActingChecklistStepMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createActingChecklistStep>>, TError,{id: string;data: BodyType<CreateActingChecklistStepBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof createActingChecklistStep>>, TError,{id: string;data: BodyType<CreateActingChecklistStepBody>}, TContext> => {
    
const mutationKey = ['createActingChecklistStep'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createActingChecklistStep>>, {id: string;data: BodyType<CreateActingChecklistStepBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  createActingChecklistStep(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateActingChecklistStepMutationResult = NonNullable<Awaited<ReturnType<typeof createActingChecklistStep>>>
    export type CreateActingChecklistStepMutationBody = BodyType<CreateActingChecklistStepBody>
    export type CreateActingChecklistStepMutationError = ErrorType<unknown>

    export const useCreateActingChecklistStep = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createActingChecklistStep>>, TError,{id: string;data: BodyType<CreateActingChecklistStepBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof createActingChecklistStep>>,
        TError,
        {id: string;data: BodyType<CreateActingChecklistStepBody>},
        TContext
      > => {

      const mutationOptions = getCreateActingChecklistStepMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const updateActingPosition = (
    id: string,
    updateActingPositionBody: BodyType<UpdateActingPositionBody>,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<UpdateActingPositionCommandResponse>(
      {url: `/api/v1/actings/${id}/position`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateActingPositionBody, signal
    },
      options);
    }
  


export const getUpdateActingPositionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateActingPosition>>, TError,{id: string;data: BodyType<UpdateActingPositionBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateActingPosition>>, TError,{id: string;data: BodyType<UpdateActingPositionBody>}, TContext> => {
    
const mutationKey = ['updateActingPosition'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateActingPosition>>, {id: string;data: BodyType<UpdateActingPositionBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateActingPosition(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateActingPositionMutationResult = NonNullable<Awaited<ReturnType<typeof updateActingPosition>>>
    export type UpdateActingPositionMutationBody = BodyType<UpdateActingPositionBody>
    export type UpdateActingPositionMutationError = ErrorType<unknown>

    export const useUpdateActingPosition = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateActingPosition>>, TError,{id: string;data: BodyType<UpdateActingPositionBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateActingPosition>>,
        TError,
        {id: string;data: BodyType<UpdateActingPositionBody>},
        TContext
      > => {

      const mutationOptions = getUpdateActingPositionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const updateActingPassager = (
    id: string,
    updatePassagerDiffBody: BodyType<UpdatePassagerDiffBody>,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<UpdatePassagerDiffCommandResponse>(
      {url: `/api/v1/actings/${id}/passager`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updatePassagerDiffBody, signal
    },
      options);
    }
  


export const getUpdateActingPassagerMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateActingPassager>>, TError,{id: string;data: BodyType<UpdatePassagerDiffBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateActingPassager>>, TError,{id: string;data: BodyType<UpdatePassagerDiffBody>}, TContext> => {
    
const mutationKey = ['updateActingPassager'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateActingPassager>>, {id: string;data: BodyType<UpdatePassagerDiffBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateActingPassager(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateActingPassagerMutationResult = NonNullable<Awaited<ReturnType<typeof updateActingPassager>>>
    export type UpdateActingPassagerMutationBody = BodyType<UpdatePassagerDiffBody>
    export type UpdateActingPassagerMutationError = ErrorType<unknown>

    export const useUpdateActingPassager = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateActingPassager>>, TError,{id: string;data: BodyType<UpdatePassagerDiffBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateActingPassager>>,
        TError,
        {id: string;data: BodyType<UpdatePassagerDiffBody>},
        TContext
      > => {

      const mutationOptions = getUpdateActingPassagerMutationOptions(options);

      return useMutation(mutationOptions);
    }
    